module.exports = __webpack_public_path__ + "images/FUSA_icons/067-delivery-truck-1.40270da92b2e5b7917a8386ce483ccce.svg";